<div>
  <div class="btn-list">
    <div class="blocked" *ngIf="entrega?.can_full_block || entrega?.can_meta_block">
      <div class="full" (click)="bloqueioEntregaProjeto(true)" *ngIf="entrega?.can_full_block" tooltip="Bloqueio Total" placement="bottom">
        <img src="assets/images/svgs/Bloquear-total.svg" alt="Bloqueio Total" *ngIf="entrega?.full_blocked">
        <img src="assets/images/svgs/Desbloquear-total.svg" alt="Desbloqueio Total" *ngIf="!entrega?.full_blocked">
      </div>
      <div class="meta" (click)="bloqueioEntregaProjeto()" *ngIf="entrega?.can_meta_block" tooltip="Bloqueio Meta" placement="bottom">
        <img src="assets/images/svgs/Bloquear-meta.svg" alt="Bloqueio Meta" *ngIf="entrega?.meta_blocked">
        <img src="assets/images/svgs/Desbloquear-meta.svg" alt="Desbloqueio Meta" *ngIf="!entrega?.meta_blocked">
      </div>
    </div>
    <div class="btn-icon">
      <img src="assets/images/svgs/Imprimir.svg" alt="Imprimir" (click)="openPrintModal()" tooltip="Imprimir" placement="bottom">
    </div>
    <div class="btn-icon" *ngIf="entrega?.can_see_edit">
      <a routerLink="editar">
        <img src="assets/images/svgs/Editar.svg" alt="Editar" tooltip="Editar" placement="bottom">
      </a>
    </div>
    <button type="button" class="btn-back" (click)="voltar()">Voltar</button>
  </div>

  <div class="list-info">
    <h4>Item do Cronograma:</h4>
    <p>{{ entrega?.description }}</p>
  </div>

  <div class="list-info">
    <h4>Tipo:</h4>
    <p>{{ entrega?.start_is_milestone || entrega?.end_is_milestone ? 'Entrega' : 'Etapa/Tarefa' }}</p>
  </div>
  <div class="list-info">
    <h4>Usuário Responsável:</h4>
    <p>{{ entrega?.resp_nome }}</p>
  </div>
  <div class="list-info">
    <h4>Responsável:</h4>
    <p>{{ entrega?.agency_name }}</p>
  </div>

  <div class="list-info" *ngIf="entrega?.ind_relantionship">
    <h4>Indicador Relacionado:</h4>
    <a routerLink="/projetos/projeto/{{entrega?.ind_relantionship?.pf_id}}/indicadores/{{entrega?.ind_relantionship?.id}}">{{ entrega?.ind_relantionship?.label }}</a>
  </div>

  <div class="list-info" *ngIf="entrega?.irfe_relantionship">
    <h4>IRFE Relacionado:</h4>
    <a routerLink="/projetos/projeto/{{entrega?.irfe_relantionship?.pf_id}}/irfe/{{entrega?.irfe_relantionship?.id}}">{{ entrega?.irfe_relantionship?.label }}</a>
  </div>

  <div class="list-info" *ngIf="entrega?.ircp_relantionship">
    <h4>IRCP Relacionado:</h4>
    <a routerLink="/projetos/projeto/{{entrega?.ircp_relantionship?.pf_id}}/ircp/{{entrega?.ircp_relantionship?.id}}">{{ entrega?.ircp_relantionship?.label }}</a>
  </div>
</div>

<div class="container_component" *ngIf="entrega?.can_see_analysis">
  <app-detalhe-entrega-projeto-analise-list [idEntrega]="entrega?.id"></app-detalhe-entrega-projeto-analise-list>
</div>

<div class="container_component" *ngIf="entrega?.can_create_critical">
  <app-detalhe-projeto-pontos-criticos-list [idEntrega]="entrega?.id"></app-detalhe-projeto-pontos-criticos-list>
</div>

<div class="container_component" *ngIf="entrega?.can_create_actions">
  <app-detalhe-projeto-plano-acao-list [isProjeto]="false" [idEntrega]="entrega?.id"></app-detalhe-projeto-plano-acao-list>
</div>

<div class="container_component" *ngIf="entrega?.can_see_cron">
  <app-detalhe-cronograma-projeto-list [isProjeto]="false" [idEntrega]="entrega?.id"></app-detalhe-cronograma-projeto-list>
</div>

<div class="container_component" *ngIf="entrega?.can_see_budget">
  <app-detalhe-execucao-orcamentaria-list [idEntrega]="entrega?.id"></app-detalhe-execucao-orcamentaria-list>
</div>

<div class="container_component" *ngIf="entrega?.can_see_doc">
  <app-detalhe-documento-list [isProjeto]="false" [idEntrega]="entrega?.id"></app-detalhe-documento-list>
</div>

<div class="container_component">
  <app-detalhe-projeto-demanda-monitoramento-list [idEntrega]="entrega.id"></app-detalhe-projeto-demanda-monitoramento-list>
</div>

<div class="container_component">
  <app-detalhe-entrega-projeto-obras-list [idEntrega]="entrega.id"></app-detalhe-entrega-projeto-obras-list>
</div>

<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
<ng-template #modalPrint>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Impressão de Relatório</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closePrintModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body table-form">
    <div class="form-group row m-b">
      <div class="col-sm-12">
        <div class="form-group row">
          <div class="switch col-2">
            <div class="onoffswitch">
              <input type="checkbox" (change)="infoImprimir.analises = !infoImprimir?.analises" [checked]="infoImprimir?.analises" class="onoffswitch-checkbox" id="analises">
              <label class="onoffswitch-label" for="analises">
                <span class="onoffswitch-inner switchCheck"></span>
                <span class="onoffswitch-switch"></span>
              </label>
            </div>
          </div>
          <label class="label-switch" for="analises">Análise</label>
        </div>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-12">
        <div class="form-group row">
          <div class="switch col-2">
            <div class="onoffswitch">
              <input type="checkbox" (change)="infoImprimir.pontos = !infoImprimir?.pontos" [checked]="infoImprimir?.pontos" class="onoffswitch-checkbox" id="pontos">
              <label class="onoffswitch-label" for="pontos">
                <span class="onoffswitch-inner switchCheck"></span>
                <span class="onoffswitch-switch"></span>
              </label>
            </div>
          </div>
          <label class="label-switch" for="pontos">Pontos Críticos</label>
        </div>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-12">
        <div class="form-group row">
          <div class="switch col-2">
            <div class="onoffswitch">
              <input type="checkbox" (change)="infoImprimir.planos = !infoImprimir?.planos" [checked]="infoImprimir?.planos" class="onoffswitch-checkbox" id="planos">
              <label class="onoffswitch-label" for="planos">
                <span class="onoffswitch-inner switchCheck"></span>
                <span class="onoffswitch-switch"></span>
              </label>
            </div>
          </div>
          <label class="label-switch" for="planos">Plano de Ação</label>
        </div>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-12">
        <div class="form-group row">
          <div class="switch col-2">
            <div class="onoffswitch">
              <input type="checkbox" (change)="infoImprimir.cronograma = !infoImprimir?.cronograma" [checked]="infoImprimir?.cronograma" class="onoffswitch-checkbox" id="cronograma">
              <label class="onoffswitch-label" for="cronograma">
                <span class="onoffswitch-inner switchCheck"></span>
                <span class="onoffswitch-switch"></span>
              </label>
            </div>
          </div>
          <label class="label-switch" for="cronograma">Cronograma</label>
        </div>
      </div>
    </div>
    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="closePrintModal()">Fechar</button>
        <button class="btn btn-primary" type="button" (click)="imprimir()">Imprimir</button>
      </div>
    </div>
  </div>
</ng-template>

<app-loading [loader]="isLoading"></app-loading>